<template>
  <div class="grid-pages">
    <slot :data="data" :loading="loading"></slot>
    <div class="paging" v-if="isPages">
      <el-pagination background
                     layout="sizes, total, prev, pager, next, jumper"
                     :current-page="currentpage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     :total="TotalCount"
                     @current-change="onCurrentChange"
                     @size-change="onSizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * @description 表格分页组件
 * @author tyx
 * @example 使用方式
 * <grid-pages ref="grid" :url="" :params="">
 *
 *   <!-- 这里放 el-table -->
 *   <el-table slot-scope="grid" :data="grid.data" v-loading="grid.loading">
 *   </el-table>
 *
 * </grid-pages>
 * @method loadData 加载数据 在父组件中调用方式 this.$refs['grid'].loadData()
 * @param url 数据请求完整地址
 * @param params 额外查询条件
 * @param manually 是否手动加载数据
 * @event loaded 数据加载完成后触发
 */

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    isPages: {
      type: Boolean,
      default: false
    },
    params: {
      type: [String, Object],
      default: ''
    },
    manually: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 50
    },
    pageSizes: {
      type: Array,
      default: () => [50, 100,500,1000,2000]
    }
  },
  data() {
    return {
      currentpage: 1,
      TotalCount: 0,
      size: 50,
      data: [],
      loading: false
    }
  },
  methods: {
    loadData(url) {
      let self = this;
      if (url == null) url = self.url;
      self.loading = true;
      if (self.isPages) {
        self.$http.post(url, {
          PageIndex: self.currentpage,
          PageSize: self.size,
          Data: self.params
        }).then(result => {
          if (result.state == true) {
            if (result.data.State == 1) {
              self.TotalCount = result.data.TotalCount;
              self.data = result.data.Data;
              self.$emit('loaded', self.data);
              self.$emit('loadedOther', result.data.SummerData?result.data.SummerData:{});
            } else {
              self.data = [];
              self.TotalCount = 0;
            }
          } else {
            self.data = [];
            self.TotalCount = 0;
          }

          self.loading = false;
        }, () => {
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
          self.loading = false;
        });
      } else {
        //2021/10/20 10:00
        //为确保以后 后端返回一致 且后端不动底层  这里 传参改为 {keyValue:'',Keyword:''},只是单纯传对象进去不用Data包裹 接受的时候 返回不分页的形式 即无分页数据 故没有Data}
        if(url){
          self.$http.post(url,
            self.params
          ).then(result => {
            if (result.state == true) {
              self.data = result.data;
            } else {
              self.data = [];
            }
            self.$emit('loaded', self.data);
            self.loading = false;
          }, () => {
            self.$message.error('获取数据失败，请检查您的网络是否可用。');
            self.loading = false;
          });
        }else{
          self.loading = false;
        }
      }

    },
    reload(url) {
      // this.currentpage = 1;
      this.loadData(url);
    },
    reloadBySearch(url){
      this.currentpage = 1;
      this.loadData(url);
    },
    onSizeChange(val) {
      this.size = val;
      this.reload();
    },
    onCurrentChange(val) {
      this.currentpage = val;
      this.loadData();
    }
  },
  mounted() {
    this.size = this.pageSize;
    if (!this.manually)
      this.loadData();
  },
  computed: {
    tableHeight() {
      return this.screen.height - 200;
    }
  }
}

</script>

<style scoped>
.grid-pages {
  background: #FFF;
}

.grid-pages .paging {
  border: 1px solid #EBEEF5;
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/tycomponents/Grid/Paging.vue